import DigitalOrderTransList from './digitalOrderTransList';

export default {
    list: DigitalOrderTransList,
};
